<div class="container">
	<div class="header">
		<h2 class="title">{{ article.name | langObservable | async }}</h2>

		<div class="active" role="region" aria-label="Active section">
			<div class="container container_allergens_info" *ngIf="article?.info?.de" role="region" aria-label="Allergens information">
				<h2 class="name">Info</h2>
				<p [innerHtml]="article?.info | langObservable | async"></p>
			</div>
			<div class="border-top" *ngIf="isAllergens()" role="region" aria-label="Allergens information">
				<h3 *ngIf="isAllergens()" class="name">{{ 'allergenes.allergenes' | translate }} *</h3>
				<ul *ngIf="article.compound?.allergens as item">
					<li *ngIf="article.compound?.allergens?.cerealsContainingGluten">
						{{ 'allergenes.cerealsWithGluten' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.crustaceansAndProductsThereof">
						{{ 'allergenes.crustaceans' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.eggsAndProductsThereof">
						{{ 'allergenes.eggs' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.fishAndProductsThereof">
						{{ 'allergenes.fish' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.peanutsAndProductsThereof">
						{{ 'allergenes.peanuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.soyaAndProductsThereof">
						{{ 'allergenes.soya' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.milkAndProductsThereof">
						{{ 'allergenes.milk' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.nuts">
						{{ 'allergenes.nuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.celeryAndProductsThereof">
						{{ 'allergenes.celery' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.mustardAndProductsThereof">
						{{ 'allergenes.mustard' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.sesameSeedsAndProductsThereof">
						{{ 'allergenes.sesame' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.sulfurDioxideAndSulphites">
						{{ 'allergenes.sulfur' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.lupinsAndProductsThereof">
						{{ 'allergenes.lupins' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.molluscsAndProductsThereof">
						{{ 'allergenes.molluscs' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.corn">
						{{ 'allergenes.corn' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.wheat">
						{{ 'allergenes.wheat' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.rye">
						{{ 'allergenes.rye' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.barley">
						{{ 'allergenes.barley' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.oats">
						{{ 'allergenes.oats' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.spelt">
						{{ 'allergenes.spelt' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.khorasan">
						{{ 'allergenes.khorasan' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.walnuts">
						{{ 'allergenes.walnuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.pecanNuts">
						{{ 'allergenes.pecanNuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.brazilNuts">
						{{ 'allergenes.brazilNuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.pistachioNuts">
						{{ 'allergenes.pistachioNuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.macadamiaNuts">
						{{ 'allergenes.macadamiaNuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.almonds">
						{{ 'allergenes.almonds' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.hazelnuts">
						{{ 'allergenes.hazelnuts' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.cashews">
						{{ 'allergenes.cashews' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.seeds">
						{{ 'allergenes.seeds' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.poppySeeds">
						{{ 'allergenes.poppySeeds' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.sunflowerSeeds">
						{{ 'allergenes.sunflowerSeeds' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.poultryMeat">
						{{ 'allergenes.poultryMeat' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.beef">
						{{ 'allergenes.beef' | translate }}
					</li>
					<li *ngIf="article.compound?.allergens?.pigmeat">
						{{ 'allergenes.pigmeat' | translate }}
					</li>
				</ul>
				<div class="padding-top"></div>
			</div>
			<div class="border-top" *ngIf="isAddit()" role="region">
				<h3 class="name" *ngIf="isAddit()">{{ 'additives.additives' | translate }} *</h3>
				<ul *ngIf="article?.compound?.additives">
					<li *ngIf="article?.compound?.additives?.blackened">
						{{ 'additives.6' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.caffeinated">
						{{ 'additives.9' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.quinine">
						{{ 'additives.10' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.sulfured">
						{{ 'additives.5' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.waxed">
						{{ 'additives.12' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withAntioxidant">
						{{ 'additives.3' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withDye">
						{{ 'additives.1' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withFlavorEnhancer">
						{{ 'additives.4' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withMilkProtein">
						{{ 'additives.8' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withPhosphate">
						{{ 'additives.7' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withPreservative">
						{{ 'additives.2' | translate }}
					</li>
					<li *ngIf="article?.compound?.additives?.withSweetener">
						{{ 'additives.11' | translate }}
					</li>
				</ul>
				<div class="padding-top"></div>
			</div>
			<div class="border-top" *ngIf="isHaveAnyValueMoreZero(article)" role="region" aria-label="Article content">
				<h2 class="name">Nährwerte (100g/ Portion) *</h2>
				<ion-row
					*ngIf="article?.nutritions?.energyKcalPer100g || article?.nutritions?.energyKcalPer100g"
					role="region"
					aria-label="Nutrition information"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{
						'nutrition.energyKjPerPortion' | translate
					}}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.energyKcalPer100g) }}
						{{ 'nutrition.energyKjPerPortionSize' | translate }}
					</ion-col>
				</ion-row>

				<ion-row
					*ngIf="article?.nutritions?.energyKcalPerPortion || article?.nutritions?.energyKcalPer100g"
					role="region"
					aria-label="Nutrition information"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{
						'nutrition.energyKcalPerPortion' | translate
					}}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.energyKcalPer100g) }}
						{{ 'nutrition.energyKcalPerPortionSize' | translate }} /
						{{ numberD(article?.nutritions?.energyKcalPerPortion) }}
						{{ 'nutrition.energyKcalPerPortionSize' | translate }}
					</ion-col>
				</ion-row>

				<ion-row
					*ngIf="article?.nutritions?.fatPerPortion || article?.nutritions?.fatPer100g"
					role="region"
					aria-label="Nutrition facts row"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{ 'nutrition.fatPerPortion' | translate }}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.fatPer100g) }}
						{{ 'nutrition.fatPerPortionSize' | translate }} /
						{{ numberD(article?.nutritions?.fatPerPortion) }}
						{{ 'nutrition.fatPerPortionSize' | translate }}
					</ion-col>
				</ion-row>
				<ion-row
					*ngIf="article?.nutritions?.saturatesPerPortion || article?.nutritions?.saturatesPer100g"
					role="region"
					aria-label="Nutritional information for saturates"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{
						'nutrition.saturatesPerPortion' | translate
					}}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.saturatesPer100g) }}
						{{ 'nutrition.portionInGSize' | translate }} /
						{{ numberD(article?.nutritions?.saturatesPerPortion) }}
						{{ 'nutrition.portionInGSize' | translate }}
					</ion-col>
				</ion-row>
				<ion-row
					*ngIf="article?.nutritions?.carbohydratePerPortion || article?.nutritions?.carbohydratePer100g"
					role="region"
					aria-label="Nutrition information"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{
						'nutrition.carbohydratePerPortion' | translate
					}}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.carbohydratePer100g) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }} /
						{{ numberD(article?.nutritions?.carbohydratePerPortion) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }}
					</ion-col>
				</ion-row>

				<ion-row
					*ngIf="article?.nutritions?.sugarPerPortion || article?.nutritions?.sugarPer100g"
					role="region"
					aria-label="Nutrition sugar information"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{ 'nutrition.sugarPerPortion' | translate }}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.sugarPer100g) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }} /
						{{ numberD(article?.nutritions?.sugarPerPortion) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }}
					</ion-col>
				</ion-row>
				<ion-row
					*ngIf="article?.nutritions?.proteinPer100g || article?.nutritions?.proteinPerPortion"
					role="region"
					aria-label="Nutrition information row"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{
						'nutrition.proteinPerPortion' | translate
					}}</ion-col>
					<ion-col size="6" class="nutrition-value">
						{{ numberD(article?.nutritions?.proteinPer100g) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }} /
						{{ numberD(article?.nutritions?.proteinPerPortion) }}
						{{ 'nutrition.sugarPerPortionSize' | translate }}
					</ion-col>
				</ion-row>
				<ion-row
					*ngIf="article?.nutritions?.saltPerPortion || article?.nutritions?.saltPer100g"
					role="region"
					aria-label="Nutrition salt information"
				>
					<ion-col class="nutrition-name" size="6" class="nutrition-name">{{ 'nutrition.saltPerPortion' | translate }}</ion-col>
					<ion-col size="6" class="nutrition-value">
						<{{ numberD(article?.nutritions?.saltPer100g) }} {{ 'nutrition.sugarPerPortionSize' | translate }} / <{{
							numberD(article?.nutritions?.saltPerPortion)
						}}
						{{ 'nutrition.sugarPerPortionSize' | translate }}
					</ion-col>
				</ion-row>
			</div>
		</div>
	</div>

	<!-- Close button with keyboard accessibility -->
	<div class="button">
		<button class="close bsg-close-button" (click)="dismiss()" tabindex="0" aria-label="Close nutrition information">
			<span class="button-text">Close</span>
		</button>
	</div>
</div>
